var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHexagons1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM16.067 9.18691L12.433 7.1146C12.1651 6.9618 11.8349 6.9618 11.567 7.1146L7.93301 9.18691C7.66506 9.33971 7.5 9.62209 7.5 9.92769V14.0723C7.5 14.3779 7.66506 14.6603 7.93301 14.8131L11.567 16.8854C11.8349 17.0382 12.1651 17.0382 12.433 16.8854L16.067 14.8131C16.3349 14.6603 16.5 14.3779 16.5 14.0723V9.92769C16.5 9.62209 16.3349 9.33971 16.067 9.18691Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagons1);
export default __webpack_public_path__ + "static/media/hexagons-1.f374d62aee31e8927cf116f0d0b6e982.svg";
export { ForwardRef as ReactComponent };